module.exports = __webpack_public_path__ + "img/xz.d47c3d10.png";